import { PANEL_HOME } from "./config";

/**
 * Çalışma Programı (stub).
 *
 * Runner bitiminde "Çalışma Programı Oluştur" buraya yönlendirir. İçerik
 * (çocuğun sonuçlarından çalışma kâğıtlarıyla program kurma) henüz yok;
 * şimdilik yer tutucu. Oturum kodu URL'den gelir: /calisma-programi/{kod}.
 */
export function StudyProgramPage({ code }: { code: string }) {
  return (
    <main
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        background: "#f6f5fa",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 460,
          background: "#fff",
          borderRadius: 14,
          boxShadow: "0 12px 40px rgba(0,0,0,.12)",
          padding: 28,
          textAlign: "center",
        }}
      >
        <h1 style={{ margin: "0 0 10px", fontSize: "1.5rem", color: "#1f2937" }}>
          Çalışma Programı
        </h1>
        <p
          style={{
            margin: "0 0 18px",
            color: "#6b6b70",
            fontSize: "1.05rem",
            lineHeight: 1.5,
          }}
        >
          Bu çalışmanın sonuçlarından çalışma kâğıtlarıyla program oluşturma
          özelliği yakında burada olacak.
        </p>
        {code && (
          <p style={{ margin: "0 0 18px", color: "#9ca3af", fontSize: ".9rem" }}>
            Oturum: {code}
          </p>
        )}
        <button
          onClick={() => {
            window.location.href = PANEL_HOME;
          }}
          style={{
            background: "#7c3aed",
            color: "#fff",
            border: "none",
            borderRadius: 10,
            padding: "12px 20px",
            fontSize: "1rem",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Anasayfaya dön
        </button>
      </div>
    </main>
  );
}
